module.exports = __webpack_public_path__ + "img/Job-Listing-Icon.1b834aed.svg";